import React, {useEffect, useState} from "react";
import {injectIntl} from "react-intl";
import NumberInput from "../../../components/NumberInput";


function OrderFavoritesNumberField(props){
    const [inputData, setInputData] = useState(props.data);

    const onInputBlur = (e) => {
        props.changeData(props.listIndex, props.productIndex, e.target.value);
    }

    const onInputChange = (e) => {
        setInputData(e.target.value);
    }

    useEffect(() => {
       setInputData(props.data)
    }, [props.data]);

    return (
        <>
            <NumberInput
                value={inputData}
                onChange={onInputChange}
                onBlur={onInputBlur}
                className={`form-control form-control-solid h-auto py-2 px-6`}
                placeholder={props.placeholder}
            />
        </>
    )
}

export default injectIntl(OrderFavoritesNumberField);